import { useLingui } from "@lingui/react/macro";
import { Box, ScrollArea, Stack, Text } from "@mantine/core";
import { AnchorLink } from "@sweco-se/reality-frontend";

import { getDocsSites } from "@/registry";

export function DocsNavbar() {
  const { i18n } = useLingui();
  const groups = getDocsSites();
  return (
    <ScrollArea type="hover" h="100%">
      <Stack gap="lg">
        {groups.map((group) => (
          <Box key={group.id ?? "_ungrouped"}>
            {group.name ? (
              <Text size="md" c="dimmed" tt="uppercase" fw={500} mb="xs">
                {i18n._(group.name)}
              </Text>
            ) : null}
            <Stack gap={4}>
              {group.entries.map((entry) => (
                <AnchorLink
                  key={entry.slug}
                  to={entry.slug}
                  activeOptions={{ exact: true }}
                  activeProps={{ fw: 700, c: "green.7" }}
                  c="inherit"
                  underline="never"
                >
                  <Text>{i18n._(entry.title)}</Text>
                </AnchorLink>
              ))}
            </Stack>
          </Box>
        ))}
      </Stack>
    </ScrollArea>
  );
}
